__turbopack_context__.v({
  "closeButton": "IKImage-module-scss-module__l4TU9q__closeButton",
  "image": "IKImage-module-scss-module__l4TU9q__image",
  "modalBody": "IKImage-module-scss-module__l4TU9q__modalBody",
});
